import React, { useMemo, useState } from 'react';
import { useInView } from '../hooks/useInView';
import { OfertaEspecialPopup } from './personaliza/OfertaEspecialPopup';
function GoldenParticles() {
  const particles = Array.from({
    length: 12
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-[2]" data-id="element-217">
      {particles.map((_, i) => {
      const left = `${Math.random() * 100}%`;
      const delay = `${Math.random() * 5}s`;
      const duration = `${8 + Math.random() * 7}s`;
      const size = Math.random() > 0.5 ? 'w-1 h-1' : 'w-1.5 h-1.5';
      return <div key={i} className={`absolute bottom-0 rounded-full bg-gold/60 ${size}`} style={{
        left,
        animation: `particleFloat ${duration} linear ${delay} infinite`
      }} data-id="element-218" />;
    })}
    </div>;
}
export function IdentitySection() {
  const [showPopup, setShowPopup] = useState(false);
  const [bgRef, bgInView] = useInView({
    rootMargin: '200px'
  });
  const [contentRef, contentInView] = useInView();
  const bgUrl = useMemo(() => {
    return 'https://cdn.magicpatterns.com/uploads/dk1sRLVWdrvqPoyxsiMxm8/retrato-del-manifestador-el-ideal-del-cliente.webp';
  }, []);
  return <section ref={bgRef} aria-label="Testimonio destacado" className="relative min-h-[70vh] sm:min-h-[90vh] flex flex-col justify-end items-center pb-12 sm:pb-20 px-4 sm:px-[5%] bg-cover bg-center" style={{
    backgroundImage: bgInView ? `url('${bgUrl}')` : 'none'
  }} data-id="element-219">
      {/* Overlay */}
      <div className="absolute inset-0 z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(0deg, #0A0A0B 10%, transparent 50%, #0A0A0B 90%)'
    }} data-id="element-220" />

      {/* Subtle center glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_50%)] pointer-events-none z-[1]" data-id="element-221" />

      {/* Particles — desktop only */}
      <div className="hidden sm:block" data-id="element-222">
        <GoldenParticles data-id="element-223" />
      </div>

      {/* Content */}
      <div ref={contentRef} className={`text-center flex flex-col items-center w-full relative z-[3] will-animate animate-fadeIn ${contentInView ? 'is-visible' : ''}`} data-id="element-224">
        <blockquote className="font-serif text-2xl sm:text-3xl md:text-[36px] font-bold text-white max-w-[700px] mb-6 sm:mb-8 leading-tight drop-shadow-lg" data-id="element-225">
          Puedes seguir igual… o hacer algo diferente por primera vez.
        </blockquote>

        <p className="text-gold font-black text-xl sm:text-2xl mb-8 sm:mb-10 drop-shadow-[0_0_10px_rgba(212,175,55,0.3)]" data-id="element-226">
          La decisión es tuya.
        </p>
      </div>

      <OfertaEspecialPopup isOpen={showPopup} onClose={() => setShowPopup(false)} data-id="element-227" />
    </section>;
}